// Author: Sparky
const REVEAL_CLASS_MAP = {
  up:         'animate-reveal-up',
  'up-short': 'animate-reveal-up-short',
  down:       'animate-reveal-down',
  'down-short': 'animate-reveal-down-short',
  left:       'animate-reveal-left',
  right:      'animate-reveal-right',
  fade:       'animate-reveal-fade',
  tile:       'animate-reveal-tile',
};

const mobileQuery = window.matchMedia('(max-width: 767px)');

function initScrollReveal() {
  const elements = document.querySelectorAll('[data-reveal]');
  if (!elements.length) return;

  const animating = new Set();

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        const direction = el.dataset.reveal;
        const once = el.dataset.revealOnce === 'true';

        if (!entry.isIntersecting) {
          if (animating.has(el)) return;

          if (direction === 'letters') {
            el.querySelectorAll('span').forEach(span => {
              span.classList.remove('animate-reveal-letter');
              span.style.opacity = '0';
            });
          } else {
            const animClass = REVEAL_CLASS_MAP[direction];
            if (animClass) el.classList.remove(animClass);
            el.style.opacity = '0';
          }
          return;
        }

        // Letter-by-letter reveal
        if (direction === 'letters') {
          const stagger = parseInt(el.dataset.revealStagger, 10) || 40;
          const spans = el.querySelectorAll('span');
          animating.add(el);
          spans.forEach((span, i) => {
            setTimeout(() => {
              span.style.opacity = '';
              span.classList.add('animate-reveal-letter');
              if (i === spans.length - 1) {
                span.addEventListener('animationend', () => animating.delete(el), { once: true });
              }
            }, i * stagger);
          });
          if (once) observer.unobserve(el);
          return;
        }

        // Directional reveal
        const animClass = REVEAL_CLASS_MAP[direction];
        const delay = parseInt(el.dataset.revealDelay, 10) || 0;

        if (!animClass) return;

        const apply = () => {
          animating.add(el);
          el.style.opacity = '';
          el.classList.add(animClass);
          el.addEventListener('animationend', () => animating.delete(el), { once: true });
        };

        delay > 0 ? setTimeout(apply, delay) : apply();

        if (once) observer.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -150px 0px', threshold: 0.1 }
  );

  elements.forEach((el) => {
    if ('revealNoMobile' in el.dataset && mobileQuery.matches) return;

    if (el.dataset.reveal === 'letters') {
      el.querySelectorAll('span').forEach(span => span.style.opacity = '0');
    } else {
      el.style.opacity = '0';
    }
    observer.observe(el);
  });
}

function initScanAnimate() {
  const el = document.querySelector('[data-scan-animate]');
  if (!el) return;

  el.addEventListener('animationend', (e) => {
    if (e.target === el && e.animationName === 'revealFromLeft') {
      el.classList.add('is-visible');
    }
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        el.classList.remove('is-visible');
      }
    });
  }, { rootMargin: '0px 0px -150px 0px', threshold: 0.1 });

  observer.observe(el);
}

// Staggered reveal — parent observed, children animate in sequence
function initStaggerReveal() {
  const containers = document.querySelectorAll('[data-reveal-stagger]');
  if (!containers.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const container = entry.target;
      const type = container.dataset.revealStagger || 'tile';
      const animClass = REVEAL_CLASS_MAP[type];
      const delayStep = parseInt(container.dataset.revealStaggerDelay, 10) || 200;
      const children = container.querySelectorAll('[data-reveal-child]');

      if (!entry.isIntersecting) {
        children.forEach((child) => {
          if (animClass) child.classList.remove(animClass);
          child.style.opacity = '0';
        });
        return;
      }

      children.forEach((child, i) => {
        setTimeout(() => {
          child.style.opacity = '';
          if (animClass) child.classList.add(animClass);
        }, i * delayStep);
      });
    });
  }, { rootMargin: '0px 0px -100px 0px', threshold: 0.1 });

  containers.forEach((container) => {
    const children = container.querySelectorAll('[data-reveal-child]');
    children.forEach((child) => { child.style.opacity = '0'; });
    observer.observe(container);
  });
}

// Simple observe — adds sp-animated class (used by SVG draw-in animations)
function initObserve() {
  const els = document.querySelectorAll('[data-sp-observe]:not(.sp-animated)');
  if (!els.length) return;
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const delay = parseInt(entry.target.getAttribute('data-sp-observe-delay')) || 300;
        setTimeout(() => entry.target.classList.add('sp-animated'), delay);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
  els.forEach((el) => obs.observe(el));
}

function initAll() {
  initScrollReveal();
  initStaggerReveal();
  initScanAnimate();
  initObserve();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);
